<template>
  <div class="filter-group">
    <button
      :class="{'selected': this.currentFilter == 'all'}"
      class="filter all"
      v-if="this.hasAllButton"
        @click="changeFilter('all')"
    >
      All
    </button>

    <div class="filter-detail">
      <button
        class="filter"
        v-for="(filter, index) in this.filters" 
        :key="index"
        :class="{
          'left': index == 0, 
          'right': index == filters.length - 1, 
          'filter-center': (index > 0 && index < filters.length - 1),
          'selected': currentFilter == filter.name.toLowerCase().trim()
        }"
        @click="changeFilter(filter.name.toLowerCase())"
      >
        {{filter.name}}
      </button>
    </div>
  </div>
</template>

<script>
	export default {
    computed : {},
    props: {
      filters: Array,
      hasAllButton: Boolean,
      currentFilter: String
    },
    methods:{
      changeFilter(filter) {
        this.$emit('selectedFilter', filter);
      }
    }
	}
</script>

<style lang="scss" scoped>
@import "@/style/base.scss";
@import "@/style/components/filters.scss";

</style>
